import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../resources/Logo petromin.png';
import stavebninyBg from '../resources/MercedesAxor.jpg';
import cerpaciaStanicaBg from '../resources/IMG_9606.jpeg';

function SplitLanding() {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 60);
    const handler = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handler);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handler);
    };
  }, []);

  const getSectionFlex = (side) => {
    if (!isDesktop) return '1 1 0%';
    if (hovered === side) return '1.4 1 0%';
    if (hovered !== null) return '0.6 1 0%';
    return '1 1 0%';
  };

  const fadeUp = (delay) => ({
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0)' : 'translateY(28px)',
    transition: `opacity 0.75s ease ${delay}ms, transform 0.75s ease ${delay}ms`,
  });

  return (
    <div className="flex flex-col md:flex-row h-screen overflow-hidden bg-black">

      {/* Logo at top center */}
      <div className="absolute inset-x-0 top-0 flex justify-center pt-6 z-30 pointer-events-none">
        <div style={fadeUp(0)}>
          <div className="bg-black/50 backdrop-blur-md rounded-2xl px-6 py-3 shadow-2xl border border-white/20">
            <img src={Logo} alt="Petromin" className="h-10" />
          </div>
        </div>
      </div>

      {/* Center divider line (desktop) */}
      <div
        className="hidden md:block absolute top-0 h-full z-20 pointer-events-none"
        style={{
          left: hovered === 'stavebniny' ? '65%' : hovered === 'cerpacia' ? '35%' : '50%',
          transform: 'translateX(-50%)',
          width: '2px',
          background: 'rgba(255,255,255,0.35)',
          boxShadow: '0 0 16px 2px rgba(255,255,255,0.25)',
          transition: 'left 0.6s cubic-bezier(0.4,0,0.2,1)',
        }}
      />

      {/* ── Left: Stavebniny ── */}
      <div
        role="button"
        tabIndex={0}
        className="relative overflow-hidden cursor-pointer outline-none"
        style={{
          flex: getSectionFlex('stavebniny'),
          transition: 'flex 0.6s cubic-bezier(0.4,0,0.2,1)',
          backgroundImage: `url(${stavebninyBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        onMouseEnter={() => isDesktop && setHovered('stavebniny')}
        onMouseLeave={() => setHovered(null)}
        onClick={() => navigate('/stavebniny')}
        onKeyDown={(e) => e.key === 'Enter' && navigate('/stavebniny')}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: hovered === 'stavebniny' ? 'rgba(0,0,0,0.28)' : 'rgba(0,0,0,0.62)',
            transition: 'background 0.55s ease',
          }}
        />
        {/* Bottom red gradient */}
        <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-red-950/70 to-transparent pointer-events-none" />

        {/* Content */}
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-8 text-center select-none">
          <div style={fadeUp(180)} className="text-6xl mb-5">
          </div>
          <h1
            style={{
              textShadow: '0 3px 24px rgba(0,0,0,0.7)',
              ...fadeUp(280),
            }}
            className="text-5xl md:text-6xl font-bold tracking-widest uppercase"
          >
            Stavebniny
          </h1>
          <p
            style={fadeUp(380)}
            className="mt-4 text-gray-300 text-base md:text-lg tracking-wide"
          >
            Kamenivo · Piesky · Štrky · Doprava
          </p>
          <div style={fadeUp(480)} className="mt-9">
            <span
              className="inline-flex items-center gap-2 px-8 py-3 border-2 rounded-full font-semibold text-lg"
              style={{
                background: hovered === 'stavebniny' ? 'rgba(220,38,38,0.92)' : 'rgba(255,255,255,0.12)',
                borderColor: hovered === 'stavebniny' ? 'transparent' : 'rgba(255,255,255,0.8)',
                transition: 'background 0.4s ease, border-color 0.4s ease',
                boxShadow: hovered === 'stavebniny' ? '0 4px 24px rgba(220,38,38,0.45)' : 'none',
              }}
            >
              Vstúpiť
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </span>
          </div>
        </div>
      </div>

      {/* ── Right: Čerpacia stanica ── */}
      <div
        role="button"
        tabIndex={0}
        className="relative overflow-hidden cursor-pointer outline-none"
        style={{
          flex: getSectionFlex('cerpacia'),
          transition: 'flex 0.6s cubic-bezier(0.4,0,0.2,1)',
          backgroundImage: `url(${cerpaciaStanicaBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        onMouseEnter={() => isDesktop && setHovered('cerpacia')}
        onMouseLeave={() => setHovered(null)}
        onClick={() => navigate('/cerpacia-stanica')}
        onKeyDown={(e) => e.key === 'Enter' && navigate('/cerpacia-stanica')}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: hovered === 'cerpacia' ? 'rgba(0,0,0,0.28)' : 'rgba(0,0,0,0.62)',
            transition: 'background 0.55s ease',
          }}
        />
        {/* Bottom red gradient */}
        <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-red-950/70 to-transparent pointer-events-none" />

        {/* Content */}
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-8 text-center select-none">
          <div style={fadeUp(240)} className="text-6xl mb-5">
          </div>
          <h1
            style={{
              textShadow: '0 3px 24px rgba(0,0,0,0.7)',
              ...fadeUp(340),
            }}
            className="text-5xl md:text-6xl font-bold tracking-widest uppercase"
          >
            Čerpacia stanica
          </h1>
          <p
            style={fadeUp(440)}
            className="mt-4 text-gray-300 text-base md:text-lg tracking-wide"
          >
            Slovnaft palivá · Rýchlo a spoľahlivo
          </p>
          <div style={fadeUp(540)} className="mt-9">
            <span
              className="inline-flex items-center gap-2 px-8 py-3 border-2 rounded-full font-semibold text-lg"
              style={{
                background: hovered === 'cerpacia' ? 'rgba(220,38,38,0.92)' : 'rgba(255,255,255,0.12)',
                borderColor: hovered === 'cerpacia' ? 'transparent' : 'rgba(255,255,255,0.8)',
                transition: 'background 0.4s ease, border-color 0.4s ease',
                boxShadow: hovered === 'cerpacia' ? '0 4px 24px rgba(220,38,38,0.45)' : 'none',
              }}
            >
              Vstúpiť
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </span>
          </div>
        </div>
      </div>

    </div>
  );
}

export default SplitLanding;
